import { hasValue } from "@repo/helpers";

import { Button, ButtonTypes } from "../basic/button";
import Col from "../basic/col";
import Row from "../basic/row";
import { Props } from "./types";

export function Form<TObj>(props: Props<TObj>) {
	function onSave() {
		props.save();
	}

	function onCancel() {
		props.cancel();
	}

	function renderActionButtons() {
		return (
			<Col>
				<Button onClick={onSave} disabled={!props.pendingChanges} types={[ButtonTypes.Primary]}>
					Save
				</Button>
				<Button onClick={onCancel} disabled={!props.pendingChanges}>
					Cancel
				</Button>
			</Col>
		);
	}

	const { obj, id } = props;
	if (!hasValue(obj)) return null;
	return (
		<section id={id}>
			{props.children}
			<Row>{renderActionButtons()}</Row>
		</section>
	);
}

Form.defaultProps = {
	pendingChanges: false,
	showButtons: true,
} as Props<any>;
